export enum EXPERIENCE_HOST_DOMAINS {
  localhost = 'localhost',
  mumbai = 'talentcentral-1a.in.shl.zone',
  euDev = 'talentcentral-1a.eu.shl.zone',
  qa1 = 'talentcentral-2b.eu.shl.zone',
  qa2 = 'talentcentral-2a.eu.shl.zone',
  qa3 = 'talentcentral-3b.eu.shl.zone',
  qa4 = 'talentcentral-3a.eu.shl.zone',
  uatAM = 'experience.aspiringminds.com',
  uatEU = 'talentcentral-uat.eu.shl.domains',
  uatUS = 'talentcentral-uat.us.shl.domains',
  stagingEU = 'talentcentral.eu.shl.domains',
  stagingUS = 'talentcentral.us.shl.domains',
  au = 'talentcentral.au.shl.com',
  cn = 'talentcentral.cn.shl.com',
  eu = 'talentcentral.eu.shl.com',
  us = 'talentcentral.us.shl.com',
  au1 = 'talentcentral.au1.shl.com',
  cn1 = 'talentcentral.cn1.shl.com',
  eu1 = 'talentcentral.eu1.shl.com',
  us1 = 'talentcentral.us1.shl.com',
}

export type EXPERIENCE_DOMAIN_CONFIG =
  | EXPERIENCE_HOST_DOMAINS.localhost
  | EXPERIENCE_HOST_DOMAINS.mumbai
  | EXPERIENCE_HOST_DOMAINS.euDev
  | EXPERIENCE_HOST_DOMAINS.qa1
  | EXPERIENCE_HOST_DOMAINS.qa2
  | EXPERIENCE_HOST_DOMAINS.qa3
  | EXPERIENCE_HOST_DOMAINS.qa4
  | EXPERIENCE_HOST_DOMAINS.uatAM
  | EXPERIENCE_HOST_DOMAINS.uatEU
  | EXPERIENCE_HOST_DOMAINS.uatUS
  | EXPERIENCE_HOST_DOMAINS.stagingEU
  | EXPERIENCE_HOST_DOMAINS.stagingUS
  | EXPERIENCE_HOST_DOMAINS.au
  | EXPERIENCE_HOST_DOMAINS.cn
  | EXPERIENCE_HOST_DOMAINS.eu
  | EXPERIENCE_HOST_DOMAINS.us
  | EXPERIENCE_HOST_DOMAINS.au1
  | EXPERIENCE_HOST_DOMAINS.cn1
  | EXPERIENCE_HOST_DOMAINS.eu1
  | EXPERIENCE_HOST_DOMAINS.us1;

type ExperienceHostname = {
  [key in EXPERIENCE_DOMAIN_CONFIG]: keyof typeof EXPERIENCE_HOST_DOMAINS;
};

export const EXPERIENCE_HOSTNAMES: ExperienceHostname = {
  localhost: 'localhost',
  'talentcentral-1a.in.shl.zone': 'mumbai',
  'talentcentral-1a.eu.shl.zone': 'euDev',
  'talentcentral-2b.eu.shl.zone': 'qa1',
  'talentcentral-2a.eu.shl.zone': 'qa2',
  'talentcentral-3b.eu.shl.zone': 'qa3',
  'talentcentral-3a.eu.shl.zone': 'qa4',
  'experience.aspiringminds.com': 'uatAM',
  'talentcentral-uat.eu.shl.domains': 'uatEU',
  'talentcentral-uat.us.shl.domains': 'uatUS',
  'talentcentral.eu.shl.domains': 'stagingEU',
  'talentcentral.us.shl.domains': 'stagingUS',
  'talentcentral.au.shl.com': 'au',
  'talentcentral.cn.shl.com': 'cn',
  'talentcentral.eu.shl.com': 'eu',
  'talentcentral.us.shl.com': 'us',
  'talentcentral.au1.shl.com': 'au1',
  'talentcentral.cn1.shl.com': 'cn1',
  'talentcentral.eu1.shl.com': 'eu1',
  'talentcentral.us1.shl.com': 'us1',
};

export enum AM_HOST_DOMAINS {
  localhost = 'https://amstaging.aspiringminds.com/',
  mumbai = 'https://amstaging.aspiringminds.com/',
  euDev = 'https://amstaging.aspiringminds.com/',
  qa1 = 'https://amstaging.aspiringminds.com/',
  qa2 = 'https://amstaging.aspiringminds.com/',
  qa3 = 'https://amstaging.aspiringminds.com/',
  qa4 = 'https://amstaging.aspiringminds.com/',
  uatAM = 'https://amstaging.aspiringminds.com/',
  uatEU = 'https://amstaging.aspiringminds.com/',
  uatUS = 'https://amstaging.aspiringminds.com/',
  stagingEU = 'https://amstaging.aspiringminds.com/',
  stagingUS = 'https://amstaging.aspiringminds.com/',
  au = 'https://au-amcat.aspiringminds.com/',
  cn = 'https://amcatglobal.aspiringminds.cn/',
  eu = 'https://eu-amcat.aspiringminds.com/',
  us = 'https://amcatglobal.aspiringminds.com/',
}

export enum AM_CODEMEET_HOST_DOMAINS {
  localhost = 'https://codemeetshl.aspiringminds.com/',
  mumbai = 'https://codemeetshl.aspiringminds.com/',
  euDev = 'https://codemeetshl.aspiringminds.com/',
  qa1 = 'https://codemeetshl.aspiringminds.com/',
  qa2 = 'https://codemeetshl.aspiringminds.com/',
  qa3 = 'https://codemeetshl.aspiringminds.com/',
  qa4 = 'https://codemeetshl.aspiringminds.com/',
  uatAM = 'https://codemeetshl.aspiringminds.com/',
  uatEU = 'https://codemeetshl.aspiringminds.com/',
  uatUS = 'https://codemeetshl.aspiringminds.com/',
  stagingEU = 'https://codemeetshl.aspiringminds.com/',
  stagingUS = 'https://codemeetshl.aspiringminds.com/',
  au = 'https://au-interviews.aspiringminds.com/',
  cn = 'https://interview.aspiringminds.cn/',
  eu = 'https://eu-interviews.aspiringminds.com/',
  us = 'https://interviews.aspiringminds.com/',
}

export enum VACDC_HOST_DOMAINS {
  localhost = 'https://vivid-vadevmum.in.shl.zone/',
  mumbai = 'https://vivid-vadevmum.in.shl.zone/',
  euDev = 'https://vivid-vadevire.eu.shl.zone/',
  qa1 = 'https://vivid-vadevqa3.eu.shl.zone/',
  qa2 = 'https://vivid-vaqaire2.eu.shl.zone/',
  qa3 = 'https://vivid-vadevqa3.eu.shl.zone/',
  qa4 = 'https://vivid-vadevqa3.eu.shl.zone/',
  uatAM = 'https://vivid-vaqaire2.eu.shl.zone/',
  uatEU = 'https://vivid-vaqaire2.eu.shl.zone/',
  uatUS = 'https://vivid-vaqaire2.eu.shl.zone/',
  stagingEU = 'https://vivid-staging1.eu.shl.domains/',
  stagingUS = 'https://vivid-staging1-us.us.shl.domains/',
  au = 'https://vivid.au.shl.com/',
  cn = 'https://vivid.cn.shl.com/',
  eu = 'https://vivid.eu.shl.com/',
  us = 'https://vivid.us.shl.com/',
}

export enum LOADTESTING_AM_DOMAINS {
  localhost = 'https://loadtesting-amcat.aspiringminds.com/',
  mumbai = 'https://loadtesting-amcat.aspiringminds.com/',
  euDev = 'https://loadtesting-amcat.aspiringminds.com/',
  qa1 = 'https://loadtesting-amcat.aspiringminds.com/',
  qa2 = 'https://loadtesting-amcat.aspiringminds.com/',
  qa3 = 'https://loadtesting-amcat.aspiringminds.com/',
  qa4 = 'https://loadtesting-amcat.aspiringminds.com/',
  uatAM = 'https://loadtesting-amcat.aspiringminds.com/',
  uatEU = 'https://loadtesting-amcat.aspiringminds.com/',
  uatUS = 'https://loadtesting-amcat.aspiringminds.com/',
  stagingEU = 'https://loadtesting-amcat.aspiringminds.com/',
  stagingUS = 'https://loadtesting-amcat.aspiringminds.com/',
  au = 'https://loadtesting-amcat.aspiringminds.com/',
  cn = 'https://loadtesting-amcat.aspiringminds.com/',
  eu = 'https://loadtesting-amcat.aspiringminds.com/',
  us = 'https://loadtesting-amcat.aspiringminds.com/',
}

export enum LOADTESTING_AM_API_DOMAINS {
  localhost = 'https://loadtesting-amcatapi.aspiringminds.com/',
  mumbai = 'https://loadtesting-amcatapi.aspiringminds.com/',
  euDev = 'https://loadtesting-amcatapi.aspiringminds.com/',
  qa1 = 'https://loadtesting-amcatapi.aspiringminds.com/',
  qa2 = 'https://loadtesting-amcatapi.aspiringminds.com/',
  qa3 = 'https://loadtesting-amcatapi.aspiringminds.com/',
  qa4 = 'https://loadtesting-amcatapi.aspiringminds.com/',
  uatAM = 'https://loadtesting-amcatapi.aspiringminds.com/',
  uatEU = 'https://loadtesting-amcatapi.aspiringminds.com/',
  uatUS = 'https://loadtesting-amcatapi.aspiringminds.com/',
  stagingEU = 'https://loadtesting-amcatapi.aspiringminds.com/',
  stagingUS = 'https://loadtesting-amcatapi.aspiringminds.com/',
  au = 'https://loadtesting-amcatapi.aspiringminds.com/',
  cn = 'https://loadtesting-amcatapi.aspiringminds.com/',
  eu = 'https://loadtesting-amcatapi.aspiringminds.com/',
  us = 'https://loadtesting-amcatapi.aspiringminds.com/',
}

export enum UP_HOST_DOMAINS {
  localhost = 'https://as1-2b-amcatfrontend.shl.zone/',
  mumbai = 'https://as1-2b-amcatfrontend.shl.zone/',
  euDev = 'https://as1-2b-amcatfrontend.shl.zone/',
  qa1 = 'https://tcplusqa1-amcat.shl.zone/',
  qa2 = 'https://tcplusqa1-amcat.shl.zone/',
  qa3 = 'https://tcplusqa1-amcat.shl.zone/',
  qa4 = 'https://tcplusstg-amcat.shl.zone/',
  uatAM = 'https://amstaging.aspiringminds.com/',
  uatEU = 'https://amstaging.aspiringminds.com/',
  uatUS = 'https://amstaging.aspiringminds.com/',
  stagingEU = 'https://amstaging.aspiringminds.com/',
  stagingUS = 'https://amstaging.aspiringminds.com/',
  au = 'https://au-amcat.aspiringminds.com/',
  cn = 'https://amcatglobal.aspiringminds.cn/',
  eu = 'https://eu-amcat.aspiringminds.com/',
  us = 'https://amcatglobal.aspiringminds.com/',
  au1 = 'https://au-amcat.aspiringminds.com/',
  cn1 = 'https://amcatglobal.aspiringminds.cn/',
  eu1 = 'https://eu-amcat.aspiringminds.com/',
  us1 = 'https://amcatglobal.aspiringminds.com/',
}

export enum AM_API_DOMAINS {
  localhost = 'https://as1-2b-amcatapi.shl.zone',
  mumbai = 'https://as1-2b-amcatapi.shl.zone',
  euDev = 'https://as1-2b-amcatapi.shl.zone',
  qa1 = 'https://tcplusqa1-amcatapi.shl.zone',
  qa2 = 'https://tcplusqa1-amcatapi.shl.zone',
  qa3 = 'https://tcplusqa1-amcatapi.shl.zone',
  qa4 = 'https://tcplusstg-amcatapi.shl.zone',
  uatAM = 'https://amstagingapi.aspiringminds.com',
  uatEU = 'https://amstagingapi.aspiringminds.com',
  uatUS = 'https://amstagingapi.aspiringminds.com',
  stagingEU = 'https://amstagingapi.aspiringminds.com',
  stagingUS = 'https://amstagingapi.aspiringminds.com',
  au = 'https://au-amcatapi.aspiringminds.com',
  cn = 'https://amcatglobalapi.aspiringminds.cn',
  eu = 'https://eu-amcatapi.aspiringminds.com',
  us = 'https://amcatglobalapi.aspiringminds.com',
  au1 = 'https://au-amcatapi.aspiringminds.com',
  cn1 = 'https://amcatglobalapi.aspiringminds.cn',
  eu1 = 'https://eu-amcatapi.aspiringminds.com',
  us1 = 'https://amcatglobalapi.aspiringminds.com',
}

export enum AM_API2_DOMAINS {
  localhost = 'https://as1-2b-api2-amcat.shl.zone',
  mumbai = 'https://as1-2b-api2-amcat.shl.zone',
  euDev = 'https://as1-2b-api2-amcat.shl.zone',
  qa1 = 'https://tcplusqa1-api2amcat.shl.zone',
  qa2 = 'https://tcplusqa1-api2amcat.shl.zone',
  qa3 = 'https://tcplusqa1-api2amcat.shl.zone',
  qa4 = 'https://tcplusstg-api2amcat.shl.zone',
  uatAM = 'https://uat-api2.aspiringminds.com',
  uatEU = 'https://uat-api2.aspiringminds.com',
  uatUS = 'https://uat-api2.aspiringminds.com',
  stagingEU = 'https://amcatglobalapi.aspiringminds.com',
  stagingUS = 'https://amcatglobalapi.aspiringminds.com',
  au = 'https://amcatglobalapi.aspiringminds.com',
  cn = 'https://amcatglobalapi.aspiringminds.com',
  eu = 'https://amcatglobalapi.aspiringminds.com',
  us = 'https://amcatglobalapi.aspiringminds.com',
  au1 = 'https://au-api2.myamcat.com',
  cn1 = 'https://api2.myamcat.cn',
  eu1 = 'https://eu-api2.myamcat.com',
  us1 = 'https://api2.myamcat.com',
}
